import "leaflet/dist/leaflet.css";
import { MapContainer } from "react-leaflet";
import ControlLayer from "../components/layers/ControlLayer";
// import '../styles/MapPage.css'
import { useState, useRef, useMemo, useEffect } from "react";
import { useSelector } from 'react-redux';
import LayersControl from '../components/controls/LayersControlNew';
import Modal from '../components/modals/Modal';
import Popup from '../components/popup/Popup';
import SearchControl from '../components/controls/SearchControl';
import SeverityControl from '../components/controls/SeverityControl';
import StatisticControl from '../components/controls/StatisticComtrol';
import UsersControl from '../components/controls/UsersControl';
import PautinaControl from '../components/controls/PautinaControl';
import Navbar from "../components/Navbar";
import { Box } from "@mui/material";
import CompassControl from "../components/controls/CompassControl";
const MapPage = () => {
    console.log('MapPage render');
    const user = useSelector(state => state.store.user);

    // Мемоизируем извлечение roles
    const roles = useMemo(() => user?.roles, [user?.roles]);

    return (
        <Box style={{ display: 'flex', flexDirection: 'row', width: '100%', height: '100%' }}>
            <Box style={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%' }}>
                <Navbar />
                <Box style={{ display: 'flex', flex: 1 }}>
                    <MapContainer
                        center={[43, 47]}
                        zoom={8}
                        scrollWheelZoom={true}
                        attributionControl={false}
                        preferCanvas={true}
                        zoomControl={false}
                        maxZoom={20}
                        // wheelPxPerZoomLevel={500}

                    >
                        <ControlLayer />
                        <LayersControl position="topright" />
                        <SearchControl position="topleft" />
                        <CompassControl position="topleft" />


                        <SeverityControl position="bottomleft" />
                        <StatisticControl position="bottomright" />
                        {roles && roles.includes('admin') ? <UsersControl position="bottomright" /> : null}
                        {/* {roles && roles.includes('admin') ? <PautinaControl position="bottomright" /> : null} */}
                        <PautinaControl position="bottomright" />
                        <Popup />
                        <Modal />
                    </MapContainer>
                </Box>
            </Box>
            {/* <Box style={{ display: 'flex', width: '300px', height: '100%' }}>

            </Box> */}

        </Box>
    )
};

MapPage.displayName = 'MapPage';

export default MapPage